import {
    DEFAULT_ERROR,
    SET_ERROR_CODES_NOT_TO_DISPLAY_DATA_ON_PANEL,
} from '@/utils/dashboard';

import { ErrorSourceList } from './ErrorSourceList';
import { ErrorActionButtons } from './ErrorActionButtons';
import { ErrorHeader } from './ErrorHeader';

export const WidgetErrorPanelErrorCard = {
    name: 'WidgetErrorPanelErrorCard',
    props: {
        sourceList: {
            type: Array,
            default() {
                return [];
            },
        },
        lastErrorSource: {
            type: Object,
            default() {
                return {};
            },
        },
        errorCode: {
            type: String,
            default: DEFAULT_ERROR,
        },
        callback: {
            type: Function,
        },
        widget: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    render() {
        const { lastErrorSource, errorCode } = this;
        const { type, canReload, canGoToConnection } = lastErrorSource;
        const doNotShow =
            SET_ERROR_CODES_NOT_TO_DISPLAY_DATA_ON_PANEL.has(errorCode);
        const hasActionButton = canReload || canGoToConnection;

        return (
            <div class="widget-error-panel__item">
                <ErrorHeader
                    errorCode={this.errorCode}
                    type={type}
                    lastErrorSource={this.lastErrorSource}
                />

                <ErrorSourceList
                    lastErrorSource={lastErrorSource}
                    sourceList={this.sourceList}
                    errorCode={this.errorCode}
                    doNotShow={doNotShow}
                />

                {hasActionButton && (
                    <ErrorActionButtons
                        canReload={canReload}
                        canGoToConnection={canGoToConnection}
                        callback={this.callback}
                        widget={this.widget}
                        onSetLoading={(v) => this.$emit('setLoading', v)}
                    />
                )}
            </div>
        );
    },
};
